import "./ApprovedTemplate.css";
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
  color: 'green'
};

const ApprovedTemplate = (props) => {   
    const [open, setOpen] = React.useState(true);
    
    const handleClose = () => setOpen(false);
    
    const microsoftDocViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=`;                        
    const fileUrl = props.outputFileName.split("===")[1];        

    return (
        <div className="data-display-new">
            {props.certificateLoading ? <CircularProgress style={{margin: '30px 50px 50px 50px'}} /> : 
            <div className="result-container">                
                {props.backButton === 'disabled' && <Modal
                    open={open}                
                    aria-labelledby="ok-modal-title"
                    aria-describedby="ok-modal-description"
                    disableEscapeKeyDown                
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                        handleClose();
                        }
                    }}
                >
                    <Box sx={style}>                    
                        <Typography id="ok-modal-description">
                            Your request has been successfully submitted. You may now view and download your certificate.
                        </Typography>                    
                        <Button
                            variant="contained"
                            onClick={handleClose}
                            sx={{ mt: 3, backgroundColor: 'blueviolet' }}
                        >
                            OK
                        </Button>
                    </Box>
                </Modal>}
                <div>
                    <div className="result-wrap">                    
                        <iframe
                            title="pptx-viewer"
                            src={microsoftDocViewerUrl + encodeURIComponent(fileUrl)}
                            width="100%"
                            height="600px"                                                        
                        />                    
                    </div>
                    <div className="file-footer">
                        <div className="return-wrap">
                            {props.backButton === 'enabled' && <p
                            onClick={() => {
                                props.setActiveScreen("default");
                                props.setL2("");
                            }}
                            >
                            {"<"} Back
                            </p>}                        
                        </div>
                        <div className="return-wrap">
                            <a href={`${fileUrl}`} download>
                                <button className="file-dwnl-btn">Download</button>
                            </a>
                        </div>                                            
                    </div>                
                </div>
            </div>}            
        </div>
    )
}

export default ApprovedTemplate;
